module.exports = __webpack_public_path__ + "static/media/Brios-Semillas-Descripcion-Desktop.1261b2b3.webp";